(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["r1-price-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('r1-price-badge')) {
    class R1PriceBadge extends HTMLElement {
      connectedCallback() {
        this.stop = new AbortController();
        let variant = this.dataset.requireSelection === 'true' ? null : {
          id: this.dataset.variantId,
          price: Number(this.dataset.price),
          compareAt: Number(this.dataset.compareAt)
        };
        const mobile = this.closest('[data-r1v2]');
        if (mobile) {
          try {
            const selected = mobile.querySelector('[data-r1v2-variant-id]')?.value;
            const variants = JSON.parse(mobile.querySelector('[data-r1v2-variants]')?.textContent || '[]');
            variant = variants.find((item) => String(item.id) === selected) || null;
          } catch (error) { variant = null; }
        }
        this.setVariant(variant);
        this.closest('.product-info')?.addEventListener('change', (event) => {
          if (event.target.closest('variant-picker')) this.hidden = true;
        }, { signal: this.stop.signal });
      }
      disconnectedCallback() { this.stop?.abort(); }
      setVariant(variant) {
        this.hidden = true;
        if (!variant?.id) return;
        const price = Number(variant.price);
        const compareAt = Number(variant.compareAt ?? variant.compare_at_price);
        if (!Number.isFinite(price) || price < 0 || !Number.isFinite(compareAt) || compareAt <= price) return;
        let amount;
        try {
          amount = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency', currency: this.dataset.currency, currencyDisplay: 'narrowSymbol'
          }).format((compareAt - price) / 100);
        } catch (error) { return; }
        this.querySelector('.r1-price-badge__pill > span').textContent = this.dataset.label.replace('__AMOUNT__', amount);
        this.hidden = false;
      }
    }
    customElements.define('r1-price-badge', R1PriceBadge);
  }
  } catch(e) { console.error(e); }
})();

})();
